// @generated by protoc-gen-es v2.4.0 with parameter "target=ts"
// @generated from file dap/v1/dap.proto (package dap.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage, GenService } from "@bufbuild/protobuf/codegenv1";
import { enumDesc, fileDesc, messageDesc, serviceDesc } from "@bufbuild/protobuf/codegenv1";
import type { ConversationalModule } from "../../agency/v1/agency_pb";
import { file_agency_v1_agency } from "../../agency/v1/agency_pb";
import type { Place } from "../../place/v1/place_pb";
import { file_place_v1_place } from "../../place/v1/place_pb";
import type { Direction, PageRequest, PageResponse } from "../../tsam/v1/page_pb";
import { file_tsam_v1_page } from "../../tsam/v1/page_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file dap/v1/dap.proto.
 */
export const file_dap_v1_dap: GenFile = /*@__PURE__*/
  fileDesc("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", [file_agency_v1_agency, file_place_v1_place, file_tsam_v1_page]);

/**
 * @generated from message dap.v1.DAP
 */
export type DAP = Message<"dap.v1.DAP"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * @generated from field: optional string last_name = 2;
   */
  lastName?: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional int32 caisse_id = 4;
   */
  caisseId?: number;

  /**
   * @generated from field: optional dap.v1.TauxPec taux_pec = 5;
   */
  tauxPec?: TauxPec;

  /**
   * @generated from field: optional place.v1.Place origin = 6;
   */
  origin?: Place;

  /**
   * @generated from field: optional place.v1.Place destination = 7;
   */
  destination?: Place;

  /**
   * @generated from field: repeated dap.v1.Transportation transportations = 8;
   */
  transportations: Transportation[];

  /**
   * @generated from field: optional int32 companions = 9;
   */
  companions?: number;

  /**
   * @generated from field: optional int32 max_journeys = 10;
   */
  maxJourneys?: number;

  /**
   * @generated from field: int32 journeys_booked = 11;
   */
  journeysBooked: number;

  /**
   * @generated from field: optional dap.v1.TrainCabinClass train_cabin_class = 12;
   */
  trainCabinClass?: TrainCabinClass;

  /**
   * @generated from field: optional dap.v1.PlaneCabinClass plane_cabin_class = 13;
   */
  planeCabinClass?: PlaneCabinClass;

  /**
   * @generated from field: optional string comment = 14;
   */
  comment?: string;

  /**
   * @generated from field: optional dap.v1.BookingType type = 15;
   */
  type?: BookingType;

  /**
   * @generated from field: dap.v1.DAPStatus status = 16;
   */
  status: DAPStatus;

  /**
   * @generated from field: map<string, string> errors = 17;
   */
  errors: { [key: string]: string };

  /**
   * @generated from field: optional bool is_corsican_fares_activated = 18;
   */
  isCorsicanFaresActivated?: boolean;

  /**
   * @generated from field: bool is_compliance_filter_enabled = 19;
   */
  isComplianceFilterEnabled: boolean;

  /**
   * @generated from field: optional int64 train_max_price_in_cents = 20;
   */
  trainMaxPriceInCents?: bigint;

  /**
   * @generated from field: optional int64 plane_max_price_in_cents = 21;
   */
  planeMaxPriceInCents?: bigint;

  /**
   * @generated from field: bool is_pec_modifiable = 22;
   */
  isPecModifiable: boolean;

  /**
   * Whether the caller may book this DAP. `type` describes the DAP itself and
   * stays factual; this answers the caller's question, since an agent is allowed
   * through some offline causes but not all of them.
   *
   * @generated from field: bool is_bookable_by_caller = 23;
   */
  isBookableByCaller: boolean;
};

/**
 * Describes the message dap.v1.DAP.
 * Use `create(DAPSchema)` to create a new message.
 */
export const DAPSchema: GenMessage<DAP> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 0);

/**
 * TODO: rename to DAPPatch
 *
 * @generated from message dap.v1.UpdateDAP
 */
export type UpdateDAP = Message<"dap.v1.UpdateDAP"> & {
  /**
   * @generated from field: string number = 1;
   */
  number: string;

  /**
   * @generated from field: optional dap.v1.TauxPec taux_pec = 2;
   */
  tauxPec?: TauxPec;

  /**
   * @generated from field: optional place.v1.Place origin = 3;
   */
  origin?: Place;

  /**
   * @generated from field: optional place.v1.Place destination = 4;
   */
  destination?: Place;

  /**
   * @generated from field: repeated dap.v1.Transportation transportations = 5;
   */
  transportations: Transportation[];

  /**
   * @generated from field: int32 journeys_booked = 6;
   */
  journeysBooked: number;

  /**
   * @generated from field: optional dap.v1.TrainCabinClass train_cabin_class = 7;
   */
  trainCabinClass?: TrainCabinClass;

  /**
   * @generated from field: optional dap.v1.PlaneCabinClass plane_cabin_class = 8;
   */
  planeCabinClass?: PlaneCabinClass;

  /**
   * @generated from field: optional string comment = 9;
   */
  comment?: string;

  /**
   * @generated from field: optional string last_name = 10;
   */
  lastName?: string;

  /**
   * @generated from field: optional string first_name = 11;
   */
  firstName?: string;

  /**
   * @generated from field: optional int32 companions = 12;
   */
  companions?: number;

  /**
   * @generated from field: optional int32 max_journeys = 13;
   */
  maxJourneys?: number;
};

/**
 * Describes the message dap.v1.UpdateDAP.
 * Use `create(UpdateDAPSchema)` to create a new message.
 */
export const UpdateDAPSchema: GenMessage<UpdateDAP> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 1);

/**
 * @generated from message dap.v1.Location
 */
export type Location = Message<"dap.v1.Location"> & {
  /**
   * @generated from oneof dap.v1.Location.location
   */
  location: {
    /**
     * @generated from field: dap.v1.Coordinates coordinates = 1;
     */
    value: Coordinates;
    case: "coordinates";
  } | {
    /**
     * @generated from field: string zip_code = 2;
     */
    value: string;
    case: "zipCode";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message dap.v1.Location.
 * Use `create(LocationSchema)` to create a new message.
 */
export const LocationSchema: GenMessage<Location> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 2);

/**
 * @generated from message dap.v1.ZipCode
 */
export type ZipCode = Message<"dap.v1.ZipCode"> & {
  /**
   * @generated from field: string zip_code = 1;
   */
  zipCode: string;
};

/**
 * Describes the message dap.v1.ZipCode.
 * Use `create(ZipCodeSchema)` to create a new message.
 */
export const ZipCodeSchema: GenMessage<ZipCode> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 3);

/**
 * @generated from message dap.v1.Coordinates
 */
export type Coordinates = Message<"dap.v1.Coordinates"> & {
  /**
   * @generated from field: optional string latitude = 1;
   */
  latitude?: string;

  /**
   * @generated from field: optional string longitude = 2;
   */
  longitude?: string;
};

/**
 * Describes the message dap.v1.Coordinates.
 * Use `create(CoordinatesSchema)` to create a new message.
 */
export const CoordinatesSchema: GenMessage<Coordinates> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 4);

/**
 * @generated from message dap.v1.ImportRequest
 */
export type ImportRequest = Message<"dap.v1.ImportRequest"> & {
  /**
   * @generated from field: bytes file_content = 1;
   */
  fileContent: Uint8Array;
};

/**
 * Describes the message dap.v1.ImportRequest.
 * Use `create(ImportRequestSchema)` to create a new message.
 */
export const ImportRequestSchema: GenMessage<ImportRequest> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 5);

/**
 * @generated from message dap.v1.ImportResponse
 */
export type ImportResponse = Message<"dap.v1.ImportResponse"> & {
  /**
   * @generated from field: repeated dap.v1.DAP daps = 1;
   */
  daps: DAP[];

  /**
   * @generated from field: int32 total = 2;
   */
  total: number;

  /**
   * @generated from field: int32 valid_count = 3;
   */
  validCount: number;

  /**
   * @generated from field: int32 ignored_count = 4;
   */
  ignoredCount: number;

  /**
   * @generated from field: int32 error_count = 5;
   */
  errorCount: number;

  /**
   * @generated from field: dap.v1.ImportErrorSummary error_summary = 6;
   */
  errorSummary?: ImportErrorSummary;

  /**
   * @generated from field: int32 updated_count = 7;
   */
  updatedCount: number;
};

/**
 * Describes the message dap.v1.ImportResponse.
 * Use `create(ImportResponseSchema)` to create a new message.
 */
export const ImportResponseSchema: GenMessage<ImportResponse> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 6);

/**
 * @generated from message dap.v1.ImportErrorSummary
 */
export type ImportErrorSummary = Message<"dap.v1.ImportErrorSummary"> & {
  /**
   * @generated from field: repeated dap.v1.ImportError errors = 1;
   */
  errors: ImportError[];
};

/**
 * Describes the message dap.v1.ImportErrorSummary.
 * Use `create(ImportErrorSummarySchema)` to create a new message.
 */
export const ImportErrorSummarySchema: GenMessage<ImportErrorSummary> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 7);

/**
 * @generated from message dap.v1.ImportError
 */
export type ImportError = Message<"dap.v1.ImportError"> & {
  /**
   * @generated from field: int32 line_number = 1;
   */
  lineNumber: number;

  /**
   * @generated from field: repeated string reasons = 2;
   */
  reasons: string[];
};

/**
 * Describes the message dap.v1.ImportError.
 * Use `create(ImportErrorSchema)` to create a new message.
 */
export const ImportErrorSchema: GenMessage<ImportError> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 8);

/**
 * @generated from message dap.v1.ListRequest
 */
export type ListRequest = Message<"dap.v1.ListRequest"> & {
  /**
   * @generated from field: tsam.v1.PageRequest page = 1;
   */
  page?: PageRequest;

  /**
   * @generated from field: dap.v1.SortRequest sort = 2;
   */
  sort?: SortRequest;

  /**
   * @generated from field: dap.v1.FiltersRequest filters = 3;
   */
  filters?: FiltersRequest;
};

/**
 * Describes the message dap.v1.ListRequest.
 * Use `create(ListRequestSchema)` to create a new message.
 */
export const ListRequestSchema: GenMessage<ListRequest> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 9);

/**
 * @generated from message dap.v1.ListResponse
 */
export type ListResponse = Message<"dap.v1.ListResponse"> & {
  /**
   * @generated from field: repeated dap.v1.DAP daps = 1;
   */
  daps: DAP[];

  /**
   * @generated from field: tsam.v1.PageResponse page = 2;
   */
  page?: PageResponse;
};

/**
 * Describes the message dap.v1.ListResponse.
 * Use `create(ListResponseSchema)` to create a new message.
 */
export const ListResponseSchema: GenMessage<ListResponse> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 10);

/**
 * @generated from message dap.v1.GetRequest
 */
export type GetRequest = Message<"dap.v1.GetRequest"> & {
  /**
   * @generated from field: string id = 1;
   */
  id: string;

  /**
   * @generated from field: string name = 2;
   */
  name: string;
};

/**
 * Describes the message dap.v1.GetRequest.
 * Use `create(GetRequestSchema)` to create a new message.
 */
export const GetRequestSchema: GenMessage<GetRequest> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 11);

/**
 * @generated from message dap.v1.GetResponse
 */
export type GetResponse = Message<"dap.v1.GetResponse"> & {
  /**
   * @generated from field: dap.v1.DAP dap = 1;
   */
  dap?: DAP;

  /**
   * @generated from field: optional string error = 2;
   */
  error?: string;

  /**
   * @generated from field: agency.v1.ConversationalModule conversational_module = 3;
   */
  conversationalModule?: ConversationalModule;
};

/**
 * Describes the message dap.v1.GetResponse.
 * Use `create(GetResponseSchema)` to create a new message.
 */
export const GetResponseSchema: GenMessage<GetResponse> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 12);

/**
 * @generated from message dap.v1.UpdateRequest
 */
export type UpdateRequest = Message<"dap.v1.UpdateRequest"> & {
  /**
   * @generated from field: dap.v1.UpdateDAP dap = 1;
   */
  dap?: UpdateDAP;
};

/**
 * Describes the message dap.v1.UpdateRequest.
 * Use `create(UpdateRequestSchema)` to create a new message.
 */
export const UpdateRequestSchema: GenMessage<UpdateRequest> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 13);

/**
 * @generated from message dap.v1.UpdateResponse
 */
export type UpdateResponse = Message<"dap.v1.UpdateResponse"> & {
  /**
   * @generated from field: dap.v1.DAP dap = 1;
   */
  dap?: DAP;
};

/**
 * Describes the message dap.v1.UpdateResponse.
 * Use `create(UpdateResponseSchema)` to create a new message.
 */
export const UpdateResponseSchema: GenMessage<UpdateResponse> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 14);

/**
 * @generated from message dap.v1.SortRequest
 */
export type SortRequest = Message<"dap.v1.SortRequest"> & {
  /**
   * @generated from field: dap.v1.Field field = 1;
   */
  field: Field;

  /**
   * @generated from field: tsam.v1.Direction direction = 2;
   */
  direction: Direction;
};

/**
 * Describes the message dap.v1.SortRequest.
 * Use `create(SortRequestSchema)` to create a new message.
 */
export const SortRequestSchema: GenMessage<SortRequest> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 15);

/**
 * @generated from message dap.v1.FiltersRequest
 */
export type FiltersRequest = Message<"dap.v1.FiltersRequest"> & {
  /**
   * @generated from field: optional string number = 1;
   */
  number?: string;

  /**
   * @generated from field: optional string last_name = 2;
   */
  lastName?: string;

  /**
   * @generated from field: optional string first_name = 3;
   */
  firstName?: string;

  /**
   * @generated from field: optional int32 caisse_id = 4;
   */
  caisseId?: number;

  /**
   * @generated from field: optional dap.v1.TauxPec taux_pec = 5;
   */
  tauxPec?: TauxPec;

  /**
   * @generated from field: optional place.v1.Place origin = 6;
   */
  origin?: Place;

  /**
   * @generated from field: optional place.v1.Place destination = 7;
   */
  destination?: Place;

  /**
   * @generated from field: repeated dap.v1.Transportation transportations = 8;
   */
  transportations: Transportation[];
};

/**
 * Describes the message dap.v1.FiltersRequest.
 * Use `create(FiltersRequestSchema)` to create a new message.
 */
export const FiltersRequestSchema: GenMessage<FiltersRequest> = /*@__PURE__*/
  messageDesc(file_dap_v1_dap, 16);

/**
 * @generated from enum dap.v1.DAPStatus
 */
export enum DAPStatus {
  /**
   * @generated from enum value: DAP_STATUS_UNSPECIFIED = 0;
   */
  DAP_STATUS_UNSPECIFIED = 0,

  /**
   * @generated from enum value: DAP_STATUS_VALID = 1;
   */
  DAP_STATUS_VALID = 1,

  /**
   * @generated from enum value: DAP_STATUS_ERROR = 2;
   */
  DAP_STATUS_ERROR = 2,
}

/**
 * Describes the enum dap.v1.DAPStatus.
 */
export const DAPStatusSchema: GenEnum<DAPStatus> = /*@__PURE__*/
  enumDesc(file_dap_v1_dap, 0);

/**
 * @generated from enum dap.v1.BookingType
 */
export enum BookingType {
  /**
   * @generated from enum value: BOOKING_TYPE_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: BOOKING_TYPE_ONLINE = 1;
   */
  ONLINE = 1,

  /**
   * @generated from enum value: BOOKING_TYPE_OFFLINE = 2;
   */
  OFFLINE = 2,
}

/**
 * Describes the enum dap.v1.BookingType.
 */
export const BookingTypeSchema: GenEnum<BookingType> = /*@__PURE__*/
  enumDesc(file_dap_v1_dap, 1);

/**
 * @generated from enum dap.v1.TauxPec
 */
export enum TauxPec {
  /**
   * @generated from enum value: TAUX_PEC_UNSPECIFIED = 0;
   */
  TAUX_PEC_UNSPECIFIED = 0,

  /**
   * @generated from enum value: TAUX_PEC_55 = 1;
   */
  TAUX_PEC_55 = 1,

  /**
   * @generated from enum value: TAUX_PEC_100 = 2;
   */
  TAUX_PEC_100 = 2,
}

/**
 * Describes the enum dap.v1.TauxPec.
 */
export const TauxPecSchema: GenEnum<TauxPec> = /*@__PURE__*/
  enumDesc(file_dap_v1_dap, 2);

/**
 * @generated from enum dap.v1.TrainCabinClass
 */
export enum TrainCabinClass {
  /**
   * @generated from enum value: TRAIN_CABIN_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRAIN_CABIN_CLASS_PREMIER = 1;
   */
  PREMIER = 1,

  /**
   * @generated from enum value: TRAIN_CABIN_CLASS_SECOND = 2;
   */
  SECOND = 2,
}

/**
 * Describes the enum dap.v1.TrainCabinClass.
 */
export const TrainCabinClassSchema: GenEnum<TrainCabinClass> = /*@__PURE__*/
  enumDesc(file_dap_v1_dap, 3);

/**
 * @generated from enum dap.v1.PlaneCabinClass
 */
export enum PlaneCabinClass {
  /**
   * @generated from enum value: PLANE_CABIN_CLASS_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: PLANE_CABIN_CLASS_BUSINESS = 1;
   */
  BUSINESS = 1,

  /**
   * @generated from enum value: PLANE_CABIN_CLASS_ECONOMY_PREMIUM = 2;
   */
  ECONOMY_PREMIUM = 2,

  /**
   * @generated from enum value: PLANE_CABIN_CLASS_ECONOMY = 3;
   */
  ECONOMY = 3,
}

/**
 * Describes the enum dap.v1.PlaneCabinClass.
 */
export const PlaneCabinClassSchema: GenEnum<PlaneCabinClass> = /*@__PURE__*/
  enumDesc(file_dap_v1_dap, 4);

/**
 * @generated from enum dap.v1.Transportation
 */
export enum Transportation {
  /**
   * @generated from enum value: TRANSPORTATION_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: TRANSPORTATION_TRAIN = 1;
   */
  TRAIN = 1,

  /**
   * @generated from enum value: TRANSPORTATION_PLANE = 2;
   */
  PLANE = 2,

  /**
   * @generated from enum value: TRANSPORTATION_BOAT = 3;
   */
  BOAT = 3,
}

/**
 * Describes the enum dap.v1.Transportation.
 */
export const TransportationSchema: GenEnum<Transportation> = /*@__PURE__*/
  enumDesc(file_dap_v1_dap, 5);

/**
 * @generated from enum dap.v1.Field
 */
export enum Field {
  /**
   * @generated from enum value: FIELD_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * @generated from enum value: FIELD_NUMBER = 1;
   */
  NUMBER = 1,

  /**
   * @generated from enum value: FIELD_FIRST_NAME = 2;
   */
  FIRST_NAME = 2,

  /**
   * @generated from enum value: FIELD_LAST_NAME = 3;
   */
  LAST_NAME = 3,

  /**
   * @generated from enum value: FIELD_CAISSE_ID = 4;
   */
  CAISSE_ID = 4,
}

/**
 * Describes the enum dap.v1.Field.
 */
export const FieldSchema: GenEnum<Field> = /*@__PURE__*/
  enumDesc(file_dap_v1_dap, 6);

/**
 * DAPService is a interface app for our internal web app
 * it allows to manage DAP ressources throughout RPC call.
 *
 * @generated from service dap.v1.DAPService
 */
export const DAPService: GenService<{
  /**
   * Import allow you to import DAPs from a csv file.
   *
   * @generated from rpc dap.v1.DAPService.Import
   */
  import: {
    methodKind: "unary";
    input: typeof ImportRequestSchema;
    output: typeof ImportResponseSchema;
  },
  /**
   * List allow you to list DAP link to the user.
   *
   * @generated from rpc dap.v1.DAPService.List
   */
  list: {
    methodKind: "unary";
    input: typeof ListRequestSchema;
    output: typeof ListResponseSchema;
  },
  /**
   * Get a DAP by its id.
   *
   * @generated from rpc dap.v1.DAPService.Get
   */
  get: {
    methodKind: "unary";
    input: typeof GetRequestSchema;
    output: typeof GetResponseSchema;
  },
  /**
   * Update a DAP.
   *
   * @generated from rpc dap.v1.DAPService.Update
   */
  update: {
    methodKind: "unary";
    input: typeof UpdateRequestSchema;
    output: typeof UpdateResponseSchema;
  },
}> = /*@__PURE__*/
  serviceDesc(file_dap_v1_dap, 0);

